import axios from "axios";
import Cookies from "js-cookie";
import { LOGIN_TIMEOUT_MS } from "@/utils/loginRequest";

const base = () => process.env.NEXT_PUBLIC_BASE_URL;
const auth = (token = Cookies.get("token")) => ({ headers: { Authorization: `Bearer ${token}` }, timeout: LOGIN_TIMEOUT_MS });
let contextCache = null;

export function rememberOnboardingContext(context, token = Cookies.get("token")) {
  if (!token || Cookies.get("token") !== token) return;
  contextCache = { token, context, expiresAt: Date.now() + 5000, request: null };
}

export async function verifyOnboardingEmail({ otp } = {}) {
  const { data } = await axios.post(`${base()}/onboarding/verify-email`, otp === undefined ? {} : { auth_otp: otp }, { ...auth(), timeout: LOGIN_TIMEOUT_MS });
  return data.user;
}

export async function sendOnboardingVerificationEmail() {
  const { data } = await axios.post(`${base()}/onboarding/resend-verification`, {}, { ...auth(), timeout: LOGIN_TIMEOUT_MS });
  return data;
}

export async function getOnboardingContext({ force = false } = {}) {
  const token = Cookies.get("token");
  if (!force && contextCache?.token === token && contextCache.context && contextCache.expiresAt > Date.now()) return contextCache.context;
  if (contextCache?.token === token && contextCache.request) return contextCache.request;
  const entry = { token, context: null, expiresAt: 0, request: null };
  const request = axios.get(`${base()}/onboarding/context`, auth(token)).then(({ data }) => {
    if (contextCache === entry) rememberOnboardingContext(data.data, token);
    return data.data;
  }).finally(() => {
    if (contextCache === entry) entry.request = null;
  });
  entry.request = request;
  contextCache = entry;
  return request;
}

export async function getOnboardingOptions() {
  const { data } = await axios.get(`${base()}/onboarding/options`, auth());
  return data.data;
}

export async function saveOnboardingProfile(fields) {
  const token = Cookies.get("token");
  const { data } = await axios.patch(`${base()}/onboarding/profile`, fields, auth(token));
  rememberOnboardingContext(data.data, token);
  return data.data;
}

export async function completeOnboarding(body = {}) {
  const { data } = await axios.post(`${base()}/onboarding/complete`, body, auth());
  contextCache = null;
  return data.data;
}

export async function inspectUserInvitation(token) {
  const { data } = await axios.get(`${base()}/user-invitations/inspect`, { params: { token }, timeout: LOGIN_TIMEOUT_MS });
  return data.data;
}

export async function registerUserInvitation(body) {
  const { data } = await axios.post(`${base()}/user-invitations/register`, body, { timeout: LOGIN_TIMEOUT_MS });
  return data.data;
}

export async function acceptUserInvitation(inviteId, token) {
  const { data } = await axios.post(`${base()}/user-invitations/${inviteId}/accept`, { token }, auth());
  return data.data;
}
